import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource-variable/bricolage-grotesque';
import './styles/global.css';
import './i18n';
import './posthog';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
